import { Injectable } from '@angular/core';
import { NapiService } from 'src/app/services/napi.service';
import { UserService } from 'src/app/services/user.service';
import { EMPTY_DETAILS } from '../calls-dashboard-page/calls-dashboard.constant';
import { AllScorecardInfo, ScorecardSection } from '../models/ai-scorecard-statistic.model';
import { AvgUserStatistic } from '../models/avg-learners-statistic.model';
import { UserLearnerStatistic, UserLearnerStatisticInterface } from '../models/learner-statistic.model';
import { ScorecardSectionProcessor } from '../models/scorecard-processor.model';
import { AiScenario, UserAiStatistics } from '../models/top-level-statistic.model';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export interface ExportCallsPayload {
  managerId:     string | null;
  delegateIds:   string[];
  aiAgentIds:    number[];
  includeIndirects: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class MyDevelopmentService {
  private accessToken = localStorage.getItem('AuthToken');

  constructor(
    private napi: NapiService,
    private userService: UserService,
    private http: HttpClient
  ) {}

  private getHeaders() {
      let headers = new HttpHeaders();
      if (!!this.accessToken) {
          headers = headers.set('Authorization', 'Bearer ' + this.accessToken);
      }
    return headers;
  }

  public getAiScenariosFiltered(): Promise<AiScenario[]> {
    const allowed = this.userService.getAllowedScenarios();
    return this.napi.get('ai-scorecard-statistic/ai-scenarios')
      .then((scenarios: AiScenario[]) => scenarios.filter(s => allowed.includes(s.id)));
  }

  public getTopLevelStat(): Promise<UserAiStatistics> {
    return this.napi.get('ai-scorecard-statistic/learner-top-level-statistics')
      .then((data: UserAiStatistics[]) => data[0]);
  }

  public getLearnerStats(aiScenarios: AiScenario[], statistics: UserAiStatistics): UserLearnerStatistic[] {
    const userId = this.userService.getCurrentUserInfo().userId;

    return aiScenarios.map(s => {
      let details = statistics.AiScorecardDetailsByUser.find(d => d.aiAgentId === s.id);
      if (!details) {details = EMPTY_DETAILS;}

      return new UserLearnerStatistic(userId, s.id, s.title, details);
    });
  }

  public getAvgStatistics(stats: UserLearnerStatisticInterface[]): AvgUserStatistic {
    return new AvgUserStatistic(stats);
  }

  public getAllCompletedCalls(): Promise<any[]> {
    return this.napi.get('aicoach/calls-for-user/')
      .then(res => res.filter(call => call.scoringStatus === 'COMPLETED'));
  }

  public getCallDetails(id: string): Promise<any> {
    return this.napi.get(`aicoach/call-details/${id}`);
  }

  public async getDiscussionAudio(callId: string): Promise<any> {
    return await this.napi.get(`discussion-audio/callAudio/${callId}`);
  }

 public exportCalls(
    groupByAgents: boolean,
    payload: ExportCallsPayload
  ): Observable<any> {

    const url = groupByAgents
      ? 'aicoach/users-calls-download'
      : 'aicoach/calls-download';

    return this.http.post(environment.appNApiUrl + url, payload, {headers: this.getHeaders()});
  }

  public getDashboardData(scenarioId: number): Promise<{ allStats: AllScorecardInfo; sectionStats: ScorecardSectionProcessor[] }> {
    const params = { aiAgents: [scenarioId] };

    return this.napi.post('ai-scorecard-statistic/learner-ai-scorecard-dashboard', params)
      .then((data: AllScorecardInfo) => {
        const sectionStats = data.sections.map(
          (d: ScorecardSection) => new ScorecardSectionProcessor(d)
        );
        return { allStats: data, sectionStats };
      });
  }
}
